import { useEffect } from "react";
import { toast } from "sonner";

/**
 * Listens for the `ditours:sw-update-available` custom event dispatched from
 * `public/index.html` when a new service worker version becomes available.
 *
 * We show a brief toast so the user knows an update is in-flight — the page
 * will auto-reload in a few hundred ms via `controllerchange` in index.html.
 */
export default function AppUpdateListener() {
  useEffect(() => {
    const onUpdate = () => {
      toast("🔄 Nova versão disponível — a actualizar…", {
        description: "A app vai recarregar automaticamente com o novo conteúdo.",
        duration: 3000,
      });
    };
    window.addEventListener("ditours:sw-update-available", onUpdate);
    return () => window.removeEventListener("ditours:sw-update-available", onUpdate);
  }, []);
  return null;
}
